const getLocationHref = () => window.location.href;
const getLocationPathname = () => window.location.pathname;

module.exports = {
  getLocationHref,
  getLocationPathname,
};
